<div
  class="flex flex-col gap-9 mt-8"
  *ngIf="!loading() && cardSystem() as system">
  <app-back-button />

  <div class="flex justify-between items-center">
    <div class="text-[30px] font-bold">{{ system.systemName || '-' }}</div>
    <div class="flex gap-3">
      <app-buttons
        *ngIf="canCurrentUserAccessReview()"
        [label]="reviewButtonLabel"
        [classes]="'text-primary-base'"
        (click)="goToSystemReview()" />
      <app-buttons
        *ngIf="canCurrentUserCorrect()"
        [label]="'Subsanar sistema de IA'"
        [classes]="'text-primary-base'"
        (click)="goToCorrection()" />
      <a
        *ngIf="canDeploySystem()"
        [href]="deployButton.url">
        <app-buttons
          [classes]="'c-button--m'"
          [label]="deployButton.label" />
      </a>
    </div>
  </div>

  <div class="flex items-center gap-3">
    <div
      class="w-4 h-4"
      [ngClass]="colorBox()"></div>
    <div class="text-md font-semibold">{{ stateTextFormat() }}</div>
    <span class="text-md text-neutral-dark">
      Creado el {{ system.creationDate | spanishDate }}, por {{ system.creationUser || '-' }}
    </span>
  </div>

  <app-review-states
    *ngIf="systemDetail()?.state !== 'REJECTED'"
    [context]="'system'"
    [stateGroups]="stateGroups"
    [activeStage]="activeStage"
    [projectState]="systemDetail()?.state ?? undefined"
    [showReviewButton]="canCurrentUserReview()"
    [reviewButtonLabel]="reviewStatesButtonLabel"
    [onReview]="goToSystemReview.bind(this)"></app-review-states>

  <div class="flex flex-col gap-6">
    <span class="text-[18px] font-bold">Datos funcionales</span>
    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col">
        <span class="text-[14px] text-neutral-dark">ID del sistema</span>
        <span class="text-md font-normal">{{ id_system || '-' }}</span>
      </div>
      <div></div>
      <div class="flex flex-col">
        <span class="text-[14px] text-neutral-dark">Proyecto asociado</span>
        <span class="text-md font-normal">{{ system.projectAssociated || '-' }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-[14px] text-neutral-dark">Tipo de sistema</span>
        <span class="text-md font-normal">{{ getSystemTypeLabel(system.systemType) }}</span>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-[14px] text-neutral-dark">Funciones o tareas a las que da soporte el sistema</span>
      <div class="flex flex-wrap gap-4">
        @for (func of system.functionOfSystem || []; track func) {
          <app-pill
            [value]="getFunctionLabel(func)"
            [classe]="'c-pill--primary'" />
        }
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-[14px] text-neutral-dark">Otras funciones o tareas</span>
      <div class="flex flex-wrap gap-4">
        @for (func of system.otherFunctions || []; track func) {
          <app-pill
            [value]="func"
            [classe]="'c-pill--primary'" />
        }
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-sm text-neutral-dark">Descripción del sistema</span>
      <span class="text-md font-normal">{{ system.description || '-' }}</span>
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-sm text-neutral-dark">Fecha estimada de despliegue del sistema</span>
      <span class="text-md font-normal">{{ system.estimatedDeployDate || '-' }}</span>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos identificativos</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Proveedor del sistema de IA</span>
          <span class="text-md font-normal py-2">{{ system.aiSystemProviderType || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Nombre del proveedor</span>
          <span class="text-md font-normal py-2">{{ system.aiProviderName || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Cuestiones técnicas</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Modelo de IA</span>
          <span class="text-md font-normal py-2">{{ system.aiModelName || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-[18px] font-bold">Datos entrada</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Volumen funcional de entradas estimado</span>
          <span class="text-md font-normal py-2">{{ system.estimatedFunctionalInputVolume || '-' }}</span>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-[18px] font-bold">Cumplimiento reglamento IA</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Papel de la administración respecto al sistema de IA</span>
          <span class="text-md font-normal py-2">{{ system.administrationRole || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Tipo de datos</span>
          <span class="text-md font-normal py-2">{{ system.dataType || '-' }}</span>
        </div>
        <div
          class="flex flex-col"
          *ngIf="system.otherDataType?.trim()">
          <span class="text-sm text-neutral-dark">Otro tipo de datos</span>
          <span class="text-md font-normal py-2">{{ system.otherDataType }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Nivel de explicabilidad del modelo</span>
          <span class="text-md font-normal py-2">{{ system.explainabilityLevel || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-[18px] font-bold">Datos económicos</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Importe contratación</span>
          <span class="text-md font-normal">{{ system.contractingImport | economicAmount }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Vigencia contratación (en meses)</span>
          <span class="text-md font-normal">{{ system.contractValidity || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Finalización vigencia contratación</span>
          <span class="text-md font-normal">{{ contractValidityDate() || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Importe anual del sistema</span>
          <span class="text-md font-normal">{{ system.annualAmount | economicAmount }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Ahorro anual estimado del sistema</span>
          <span class="text-md font-normal">{{ system.estimatedAnnualSavings | economicAmount }}</span>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Gestión del riesgo</span>
      <div class="grid grid-cols-2 gap-3">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Clasificación del sistema</span>
          <span
            class="text-md font-semibold"
            [ngClass]="system.systemClassification | riskLevelClass">
            {{ getRiskLevelLabel(system.systemClassification) }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <desy-collapsible>
        <span class="text-xl font-bold">Proyectos relacionados</span>
        <desy-content>
          <div class="flex flex-col flex-1">
            @for (card of system.infoCard || []; track card.id) {
              <app-project-card
                [projectName]="card.projectName || '-'"
                [state]="card.state || '-'"
                [buttons]="card.buttons || []"
                [creationUser]="card.creationUser || '-'"
                [creationDate]="card.date ?? projectCardFallbackDate"
                [infoCard]="card.infoCard ?? []"
                [description]="card.description || '-'" />
            }
          </div>
        </desy-content>
      </desy-collapsible>
    </div>
  </div>
</div>
